import { Injectable }                 from '@angular/core';
import { Response }                   from '@angular/http';
import { FormGroup, FormBuilder,
        Validators, FormControl }     from '@angular/forms';

import { ApiService }                 from '../root-services/api.service';
import { CurrentUserService }         from '../shared/services/current-user.service';
import { Subscription }               from './models/subscription';
import { SubscriptionUser }           from './models/subscription-user';
import { SubscriptionPlan }           from './models/subscription-plan';
import { SubscriptionTeam }           from './models/subscription-team';
import { SubscriptionChannel }        from './models/subscription-channel';
import { SubscriptionInvoice }        from './models/subscription-invoice';
import { SubscriptionFilters }        from './models/subscription-filters';

// RxJS Interfaces

import { BehaviorSubject }            from 'rxjs/BehaviorSubject';
import { Observable }                 from 'rxjs/Observable';

@Injectable()

export class SubscriptionsService {

  constructor(private api: ApiService, private currentUser: CurrentUserService) {
    console.log('creating subscriptions service');
  }

  /**
   * Public Methods
   */

  public getSubscriptions(filters: SubscriptionFilters, since?: number): Observable<Subscription[]> {
    let url = `/subscriptions?search=${filters.search}&buyer_type=${filters.buyer_type}`;
    if (since) {
      url += `&since=${since}`;
    }
    return this.api.get(url)
        .map((response: Response) => response.json() as Subscription[])
        .publishReplay(1).refCount()
        .catch(this.handleError);
  }

  public getSubscription(subscriptionId: number): Observable<Subscription> {
    return this.api.get(`/subscriptions/${subscriptionId}`)
        .map((response: Response) => response.json() as Subscription)
        .publishReplay(1).refCount()
        .catch(this.handleError);
  }

  public getSubscriptionUsers(subscriptionId: number): Observable<SubscriptionUser[]> {
    return this.api.get(`/subscriptions/${subscriptionId}/users`)
        .map((response: Response) => response.json() as SubscriptionUser[])
        .publishReplay(1).refCount()
        .catch(this.handleError);
  }

  public addUsersToSubscription(subscriptionId: number, users: any): Observable<void> {
    return this.api.post(`/subscriptions/${subscriptionId}/users`, users)
        .publishReplay(1).refCount()
        .catch(this.handleError);
  }

  public getSubscriptionInvoices(subscriptionId: number): Observable<SubscriptionInvoice[]> {
    return this.api.get(`/subscriptions/${subscriptionId}/invoices`)
        .map((response: Response) => response.json() as SubscriptionInvoice[])
        .publishReplay(1).refCount()
        .catch(this.handleError);
  }

  public setUserAdmin(subscriptionId: number, userId: number, state: boolean): Observable<void> {
    return this.api.patch(`/subscriptions/${subscriptionId}/users/${userId}`, {is_admin: state})
        .publishReplay(1).refCount()
        .catch(this.handleError);
  }

  public setUserActive(subscriptionId: number, userId: number, state: boolean): Observable<void> {
    return this.api.patch(`/subscriptions/${subscriptionId}/users/${userId}`, {active: state})
        .publishReplay(1).refCount()
        .catch(this.handleError);
  }

  public linkUserToInvitation(userId: number, invitationId: number, subscriptionId: number): Observable<void> {
    return this.api.post(`/subscriptions/${subscriptionId}/users/${invitationId}`, {action: 'link_user', user_id: userId})
        .publishReplay(1).refCount()
        .catch(this.handleError);
  }

  public updateSubscription(subscriptionId: number, settings: any): Observable<void> {
    return this.api.patch(`/subscriptions/${subscriptionId}`, settings)
        .publishReplay(1).refCount()
        .catch(this.handleError);
  }

  public removeInvitation(invitationId: number, subscriptionId: number): Observable<void> {
    return this.api.delete(`/subscriptions/${subscriptionId}/users/${invitationId}`)
        .publishReplay(1).refCount()
        .catch(this.handleError);
  }

  public getSubscriptionTeams(subscriptionId: number): Observable<SubscriptionTeam[]> {
    return this.api.get(`/subscriptions/${subscriptionId}/teams`)
        .map((response: Response) => response.json() as SubscriptionTeam[])
        .publishReplay(1).refCount()
        .catch(this.handleError);
  }

  public removeSubscriptionTeam(subscriptionId: number, teamId: number): Observable<void> {
    return this.api.delete(`/subscriptions/${subscriptionId}/teams/${teamId}`)
        .publishReplay(1).refCount()
        .catch(this.handleError);
  }

  public addSubscriptionTeam(subscriptionId: number, teamId: number): Observable<void> {
    return this.api.put(`/subscriptions/${subscriptionId}/teams/${teamId}`, null)
        .publishReplay(1).refCount()
        .catch(this.handleError);
  }

  public getSubscriptionHistory(subscriptionId: number): Observable<any[]> {
    return this.api.get(`/subscriptions/${subscriptionId}/history`)
        .map((response: Response) => response.json())
        .publishReplay(1).refCount()
        .catch(this.handleError);
  }

  public addHistoryNote(subscriptionId: number, description: string): Observable<void> {
    return this.api.post(`/subscriptions/${subscriptionId}/history`, {description})
        .publishReplay(1).refCount()
        .catch(this.handleError);
  }

  public getChannels(): Observable<SubscriptionChannel[]> {
    return this.api.get(`/community/channels`)
        .map((response: Response) => response.json() as SubscriptionChannel)
        .publishReplay(1).refCount()
        .catch(this.handleError);
  }

  public getPlans(): Observable<SubscriptionPlan[]> {
    return this.api.get(`/subscription-plans`)
        .map((response: Response) => response.json() as SubscriptionPlan)
        .publishReplay(1).refCount()
        .catch(this.handleError);
  }

  /**
   * Private Methods
   */

  private handleError(error: any): Promise<any> {
    console.error('An error occurred', error);
    return Promise.reject(error.message || error);
  }

}



// WEBPACK FOOTER //
// /home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/src/app/subscriptions/subscriptions.service.ts